// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { collection, getDocs } from "firebase/firestore";
// import { db } from "../../firebase-config";
// import { useAuth } from "../../provider/Auth.provider";
// import LmsBuyDrawer from "./LmsBuyDrawer/LmsBuyDrawer";
// import ButtonComponent from "../CssComponents/ButtonComponent/ButtonComponent";
// import SearchInput from "../CssComponents/SearchInput/SearchInput";
// import graduation_cap from "../../assets/graduation_cap.png";
// import time_png from "../../assets/time.png";
// import { Checkbox } from "antd";
// import { getClubTrainersWithIdAndNameOnly } from "../../service/getUsers/getClubTrainers";
// import BreadcrumbComponent from "../CssComponents/BreadCrumbComponents";

// function PackageListView({ userData, fetchUserData }) {
//   const navigate = useNavigate();
//   const { user } = useAuth();

//   const [packages, setPackages] = useState([]);
//   const [filteredPackages, setFilteredPackages] = useState([]);

//   const [buyItem, setBuyItem] = useState(null);
//   const [isDrawerVisible, setIsDrawerVisible] = useState(false);

//   const [selectedInstructors, setSelectedInstructors] = useState([]);
//   const [selectedPackageType, setSelectedPackageType] = useState("all"); // Default to 'all'
//   const [selectedPriceFilter, setSelectedPriceFilter] = useState("all"); // Default to 'all'

//   const [trainers, setTrainers] = useState([]);

//   const packageType = [
//     { label: "All", value: "all" },
//     { label: "Digital Product", value: "package_dp" },
//     { label: "Live Classes", value: "package_lc" },
//   ];

//   const priceFilters = [
//     { name: "Low to High", key: "low-to-high" },
//     { name: "High to Low", key: "high-to-low" },
//     { name: "Paid", key: "paid" },
//     { name: "Free", key: "free" },
//     { name: "All", key: "all" },
//   ];

//   useEffect(() => {
//     const fetchTrainers = async () => {
//       const trainers = await getClubTrainersWithIdAndNameOnly();
//       setTrainers(trainers);
//     };
//     fetchTrainers();
//   }, []);

//   const breadcrumbItems = [{ name: "Home", url: "/" }, { name: "Package" }];
//   const fetchPackages = async () => {
//     try {
//       const querySnapshot = await getDocs(collection(db, "lms_package"));
//       console.log("anurag test ", querySnapshot);

//       const packageData = querySnapshot.docs.map((doc) => ({
//         id: doc.id,
//         ...doc.data(),
//       }));
//       console.log("Package Data:", packageData);

//       setPackages(packageData);
//     } catch (error) {
//       console.error("Error fetching packages:", error);
//     }
//   };
//   useEffect(() => {
//     fetchPackages();
//   }, []);

//   console.log(packages);

//   const handleCardClick = (packageId) => {
//     navigate(`/package/${packageId}`);
//   };

//   const handleBuyClick = (item) => {
//     setBuyItem(item);
//     setIsDrawerVisible(true);
//   };

//   const closeDrawer = () => {
//     setIsDrawerVisible(false);
//     setBuyItem(null);
//   };

//   const handleInstructorChange = (instructor) => {
//     const updatedInstructors = selectedInstructors.includes(instructor)
//       ? selectedInstructors.filter((inst) => inst !== instructor)
//       : [...selectedInstructors, instructor];
//     setSelectedInstructors(updatedInstructors);
//   };

//   const handlePriceChange = (price) => {
//     setSelectedPriceFilter(price);
//   };

//   console.log("selected instructors", selectedInstructors);
//   console.log("selected price filter", selectedPriceFilter);

//   useEffect(() => {
//     const filterPackages = () => {
//       if (packages.length === 0) return;

//       let filteredPackages = [...packages];

//       // Filter by package type
//       if (selectedPackageType && selectedPackageType !== "all") {
//         filteredPackages = filteredPackages.filter(
//           (pkg) => pkg.packageType === selectedPackageType
//         );
//       }

//       if (selectedPriceFilter) {
//         if (selectedPriceFilter === "low-to-high") {
//           filteredPackages.sort(
//             (a, b) =>
//               parseFloat(a.packagePrice || a.registrationPrice || 0) -
//               parseFloat(b.packagePrice || b.registrationPrice || 0)
//           );
//         } else if (selectedPriceFilter === "high-to-low") {
//           filteredPackages.sort(
//             (a, b) =>
//               parseFloat(b.packagePrice || b.registrationPrice || 0) -
//               parseFloat(a.packagePrice || a.registrationPrice || 0)
//           );
//         } else if (selectedPriceFilter === "paid") {
//           filteredPackages = filteredPackages.filter(
//             (pkg) =>
//               parseFloat(pkg.packagePrice || pkg.registrationPrice || 0) > 0
//           );
//         } else if (selectedPriceFilter === "free") {
//           filteredPackages = filteredPackages.filter(
//             (pkg) =>
//               parseFloat(pkg.packagePrice || pkg.registrationPrice || 0) === 0
//           );
//         } else if (selectedPriceFilter === "all") {
//           // No filtering needed for 'all'
//         }
//       }
//       setFilteredPackages(filteredPackages);
//     };
//     filterPackages();
//   }, [selectedPriceFilter, packages, selectedPackageType]);

//   return (
//     <>
//       <div className="bg-black text-white font-poppins py-10 px-14 flex flex-col gap-4 w-full">
//         <BreadcrumbComponent items={breadcrumbItems} />

//         <div className="flex gap-8 w-full">
//           <div className="flex flex-col gap-6 w-full">
//             <div className="flex justify-between">
//               <h1 className="text-2xl font-medium">All Packages</h1>
//               <SearchInput />
//             </div>

//             {filteredPackages && filteredPackages?.length > 0 ? (
//               <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 ">
//                 {filteredPackages?.map((pkg) => (
//                   <div
//                     key={pkg.packageId}
//                     className="flex flex-col items-start w-full bg-secondary-bg rounded-xl overflow-hidden"
//                   >
//                     <img
//                       src={pkg.packageBanner}
//                       alt={pkg.packageName}
//                       className="w-full h-full object-cover max-h-64 object-top"
//                     />

//                     <div className="w-full py-4 px-6 flex flex-col gap-4">
//                       <div className="flex flex-col gap-2">
//                         <h2 className="text-xl font-medium leading-9">
//                           {pkg.packageName}
//                         </h2>
//                         <div className="flex gap-4 text-sm text-gray-400">
//                           <div className="flex items-center gap-2">
//                             <img
//                               src={time_png}
//                               alt={"time"}
//                               className="h-4 w-4"
//                             />
//                             <div>{pkg.packageDuration}</div>
//                           </div>
//                           <div className="flex items-center gap-2">
//                             <img
//                               src={graduation_cap}
//                               alt={"graduation"}
//                               className="h-4 w-4"
//                             />
//                             <div>{pkg.totalStudents} Students</div>
//                           </div>
//                         </div>
//                       </div>

//                       <hr className="w-full border-t border-gray-500" />

//                       <div className="w-full flex justify-between items-center">
//                         <div className="bg-custom-gradient bg-clip-text text-transparent text-2xl">
//                           ₹{" "}
//                           {parseFloat(
//                             pkg?.packagePrice || pkg?.registrationPrice || 0
//                           ).toLocaleString("en-IN")}
//                         </div>
//                         {userData?.buyItemIdsArray.some(
//                           (item) => item.buyItemId === pkg.id
//                         ) ? (
//                           <span className="text-green-600 font-semibold">
//                             Already Purchased
//                           </span>
//                         ) : (
//                           <ButtonComponent
//                             onClick={() => handleBuyClick(pkg)}
//                             buttonText={"Buy Now"}
//                           />
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             ) : (
//               <div className="text-gray-400 text-lg">
//                 <p>No packages available at the moment.</p>
//               </div>
//             )}
//           </div>

//           <div className="w-1/3 flex flex-col gap-8">
//             <div className="flex flex-col gap-4">
//               <label className="text-xl font-semibold text-white">
//                 Package Type
//               </label>
//               <div className="flex flex-col gap-2">
//                 {packageType.map((item) => (
//                   <div key={item.value} className="flex items-center gap-2">
//                     <Checkbox
//                       id={item.value}
//                       checked={selectedPackageType === item.value}
//                       onChange={() => setSelectedPackageType(item.value)}
//                     />
//                     <label
//                       htmlFor={item.value}
//                       className="text-lg font-normal text-gray-400"
//                     >
//                       {item.label}
//                     </label>
//                   </div>
//                 ))}
//               </div>
//             </div>

//             <div className="flex flex-col gap-4">
//               <label className=" text-xl font-semibold text-white">
//                 Instructor
//               </label>
//               <div className="flex flex-col gap-2">
//                 {trainers?.map((item) => (
//                   <div key={item.trainerId} className="flex gap-2 items-center">
//                     <Checkbox
//                       id={item.trainerId}
//                       checked={selectedInstructors.includes(item.trainerId)}
//                       onChange={() => handleInstructorChange(item.trainerId)}
//                     />
//                     <label
//                       htmlFor={item}
//                       className="text-lg font-normal text-gray-400"
//                     >
//                       {item.trainerName}
//                     </label>
//                   </div>
//                 ))}
//               </div>
//             </div>
//             <div className="flex flex-col gap-4">
//               <label className="text-xl font-semibold text-white">Price</label>
//               <div className="flex flex-col gap-2">
//                 {priceFilters.map((price) => (
//                   <div key={price.key} className="flex items-center gap-2">
//                     <Checkbox
//                       id={price.key}
//                       checked={selectedPriceFilter === price.key}
//                       onChange={() => handlePriceChange(price.key)}
//                     />
//                     <label
//                       htmlFor={price.key}
//                       className="text-lg font-normal text-gray-400"
//                     >
//                       {price.name}
//                     </label>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Drawer Component */}
//       {buyItem && (
//         <LmsBuyDrawer
//           isVisible={isDrawerVisible}
//           onClose={closeDrawer}
//           buyItemPrice={buyItem?.packagePrice}
//           buyItemName={buyItem?.packageName}
//           buyItemId={buyItem?.packageId}
//           buyItemBanner={buyItem?.packageBanner}
//           buyItemType={buyItem?.packageType}
//           buyItemBatchIds={buyItem?.packageContainingBatches}
//           fetchPackages={fetchPackages}
//           fetchUserData={fetchUserData}
//           uid={user?.uid}
//         />
//       )}
//     </>
//   );
// }

// export default PackageListView;
// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { collection, getDocs } from "firebase/firestore";
// import { db } from "../../firebase-config";
// import { useAuth } from "../../provider/Auth.provider";
// import LmsBuyDrawer from "./LmsBuyDrawer/LmsBuyDrawer";
// import ButtonComponent from "../CssComponents/ButtonComponent/ButtonComponent";
// import SearchInput from "../CssComponents/SearchInput/SearchInput";
// import graduation_cap from "../../assets/graduation_cap.png";
// import time_png from "../../assets/time.png";
// import { Checkbox } from "antd";
// import { getClubTrainersWithIdAndNameOnly } from "../../service/getUsers/getClubTrainers";
// import BreadcrumbComponent from "../CssComponents/BreadCrumbComponents";

// function PackageListView({ userData, fetchUserData }) {
//   const navigate = useNavigate();
//   const { user } = useAuth();

//   const [packages, setPackages] = useState([]);
//   const [filteredPackages, setFilteredPackages] = useState([]);
//   const [buyItem, setBuyItem] = useState(null);
//   const [isDrawerVisible, setIsDrawerVisible] = useState(false);
//   const [selectedInstructors, setSelectedInstructors] = useState([]);
//   const [selectedPackageType, setSelectedPackageType] = useState("all");
//   const [selectedPriceFilter, setSelectedPriceFilter] = useState("all");
//   const [searchTerm, setSearchTerm] = useState(""); // State for search term
//   const [trainers, setTrainers] = useState([]);
//   console.log(searchTerm, "getting search");
//   const packageType = [
//     { label: "All", value: "all" },
//     { label: "Digital Product", value: "package_dp" },
//     { label: "Live Classes", value: "package_lc" },
//   ];

//   const priceFilters = [
//     { name: "Low to High", key: "low-to-high" },
//     { name: "High to Low", key: "high-to-low" },
//     { name: "Paid", key: "paid" },
//     { name: "Free", key: "free" },
//     { name: "All", key: "all" },
//   ];

//   useEffect(() => {
//     const fetchTrainers = async () => {
//       const trainers = await getClubTrainersWithIdAndNameOnly();
//       setTrainers(trainers);
//     };
//     fetchTrainers();
//   }, []);

//   const breadcrumbItems = [{ name: "Home", url: "/" }, { name: "Package" }];

//   const fetchPackages = async () => {
//     try {
//       const querySnapshot = await getDocs(collection(db, "lms_package"));
//       const packageData = querySnapshot.docs.map((doc) => ({
//         id: doc.id,
//         ...doc.data(),
//       }));
//       setPackages(packageData);
//     } catch (error) {
//       console.error("Error fetching packages:", error);
//     }
//   };

//   useEffect(() => {
//     fetchPackages();
//   }, []);

//   const handleBuyClick = (item) => {
//     setBuyItem(item);
//     setIsDrawerVisible(true);
//   };

//   const closeDrawer = () => {
//     setIsDrawerVisible(false);
//     setBuyItem(null);
//   };

//   const handleInstructorChange = (instructor) => {
//     const updatedInstructors = selectedInstructors.includes(instructor)
//       ? selectedInstructors.filter((inst) => inst !== instructor)
//       : [...selectedInstructors, instructor];
//     setSelectedInstructors(updatedInstructors);
//   };

//   const handlePriceChange = (price) => {
//     setSelectedPriceFilter(price);
//   };

//   // Handle search input change
//   const handleSearchChange = (value) => {
//     // Handle both event objects and direct values
//     const searchValue = value?.target?.value ?? value ?? "";
//     setSearchTerm(searchValue);
//   };

//   useEffect(() => {
//     const filterPackages = () => {
//       if (packages.length === 0) {
//         setFilteredPackages([]);
//         return;
//       }

//       let filtered = [...packages];

//       // 1️⃣ Filter by search term
//       if (searchTerm.trim() !== "") {
//         const term = searchTerm.toLowerCase();
//         filtered = filtered.filter((pkg) =>
//           (pkg.packageName || pkg.name || pkg.title || "")
//             .toLowerCase()
//             .includes(term)
//         );
//       }

//       // 2️⃣ Filter by package type
//       if (selectedPackageType && selectedPackageType !== "all") {
//         filtered = filtered.filter(
//           (pkg) => pkg.packageType === selectedPackageType
//         );
//       }

//       // 3️⃣ Filter by instructors
//       if (selectedInstructors.length > 0) {
//         filtered = filtered.filter((pkg) =>
//           selectedInstructors.includes(pkg.trainerId)
//         );
//       }

//       // 4️⃣ Filter by price
//       if (selectedPriceFilter) {
//         if (selectedPriceFilter === "low-to-high") {
//           filtered.sort(
//             (a, b) =>
//               parseFloat(a.packagePrice || a.registrationPrice || 0) -
//               parseFloat(b.packagePrice || b.registrationPrice || 0)
//           );
//         } else if (selectedPriceFilter === "high-to-low") {
//           filtered.sort(
//             (a, b) =>
//               parseFloat(b.packagePrice || b.registrationPrice || 0) -
//               parseFloat(a.packagePrice || a.registrationPrice || 0)
//           );
//         } else if (selectedPriceFilter === "paid") {
//           filtered = filtered.filter(
//             (pkg) =>
//               parseFloat(pkg.packagePrice || pkg.registrationPrice || 0) > 0
//           );
//         } else if (selectedPriceFilter === "free") {
//           filtered = filtered.filter(
//             (pkg) =>
//               parseFloat(pkg.packagePrice || pkg.registrationPrice || 0) === 0
//           );
//         }
//       }

//       setFilteredPackages(filtered);
//     };

//     filterPackages();
//   }, [
//     packages,
//     selectedPackageType,
//     selectedPriceFilter,
//     searchTerm,
//     selectedInstructors,
//   ]);

//   return (
//     <>
//       <div className="bg-black text-white font-poppins py-10 px-14 flex flex-col gap-4 w-full">
//         <BreadcrumbComponent items={breadcrumbItems} />

//         <div className="flex gap-8 w-full">
//           <div className="flex flex-col gap-6 w-full">
//             <div className="flex justify-between">
//               <h1 className="text-2xl font-medium">All Packages</h1>

//               {/* Updated SearchInput integration */}
//               <input
//                 className=" p-4 py-2 bg-black border border-yellow-500 rounded outline-none"
//                 value={searchTerm}
//                 onChange={handleSearchChange} // Use new handler
//                 placeholder="Search packages..."
//               />
//             </div>

//             {filteredPackages && filteredPackages.length > 0 ? (
//               <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 ">
//                 {filteredPackages.map((pkg) => (
//                   <div
//                     key={pkg.packageId}
//                     className="flex flex-col items-start w-full bg-secondary-bg rounded-xl overflow-hidden"
//                   >
//                     <img
//                       src={pkg.packageBanner}
//                       alt={pkg.packageName}
//                       className="w-full h-full object-cover max-h-64 object-top"
//                     />
//                     <div className="w-full py-4 px-6 flex flex-col gap-4">
//                       <div className="flex flex-col gap-2">
//                         <h2 className="text-xl font-medium leading-9">
//                           {pkg.packageName}
//                         </h2>
//                         <div className="flex gap-4 text-sm text-gray-400">
//                           <div className="flex items-center gap-2">
//                             <img
//                               src={time_png}
//                               alt="time"
//                               className="h-4 w-4"
//                             />
//                             <div>{pkg.packageDuration}</div>
//                           </div>
//                           <div className="flex items-center gap-2">
//                             <img
//                               src={graduation_cap}
//                               alt="graduation"
//                               className="h-4 w-4"
//                             />
//                             <div>{pkg.totalStudents} Students</div>
//                           </div>
//                         </div>
//                       </div>
//                       <hr className="w-full border-t border-gray-500" />
//                       <div className="w-full flex justify-between items-center">
//                         <div className="bg-custom-gradient bg-clip-text text-transparent text-2xl">
//                           ₹{" "}
//                           {parseFloat(
//                             pkg?.packagePrice || pkg?.registrationPrice || 0
//                           ).toLocaleString("en-IN")}
//                         </div>
//                         {userData?.buyItemIdsArray?.some(
//                           (item) => item.buyItemId === pkg.id
//                         ) ? (
//                           <span className="text-green-600 font-semibold">
//                             Already Purchased
//                           </span>
//                         ) : (
//                           <ButtonComponent
//                             onClick={() => handleBuyClick(pkg)}
//                             buttonText="Buy Now"
//                           />
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             ) : (
//               <div className="text-gray-400 text-lg">
//                 <p>No packages available at the moment.</p>
//               </div>
//             )}
//           </div>

//           {/* Right Sidebar Filters */}
//           <div className="w-1/3 flex flex-col gap-8">
//             <div className="flex flex-col gap-4">
//               <label className="text-xl font-semibold text-white">
//                 Package Type
//               </label>
//               <div className="flex flex-col gap-2">
//                 {packageType.map((item) => (
//                   <div key={item.value} className="flex items-center gap-2">
//                     <Checkbox
//                       id={item.value}
//                       checked={selectedPackageType === item.value}
//                       onChange={() => setSelectedPackageType(item.value)}
//                     />
//                     <label
//                       htmlFor={item.value}
//                       className="text-lg font-normal text-gray-400"
//                     >
//                       {item.label}
//                     </label>
//                   </div>
//                 ))}
//               </div>
//             </div>

//             <div className="flex flex-col gap-4">
//               <label className="text-xl font-semibold text-white">
//                 Instructor
//               </label>
//               <div className="flex flex-col gap-2">
//                 {trainers?.map((item) => (
//                   <div key={item.trainerId} className="flex gap-2 items-center">
//                     <Checkbox
//                       id={item.trainerId}
//                       checked={selectedInstructors.includes(item.trainerId)}
//                       onChange={() => handleInstructorChange(item.trainerId)}
//                     />
//                     <label
//                       htmlFor={item.trainerId}
//                       className="text-lg font-normal text-gray-400"
//                     >
//                       {item.trainerName}
//                     </label>
//                   </div>
//                 ))}
//               </div>
//             </div>

//             <div className="flex flex-col gap-4">
//               <label className="text-xl font-semibold text-white">Price</label>
//               <div className="flex flex-col gap-2">
//                 {priceFilters.map((price) => (
//                   <div key={price.key} className="flex items-center gap-2">
//                     <Checkbox
//                       id={price.key}
//                       checked={selectedPriceFilter === price.key}
//                       onChange={() => handlePriceChange(price.key)}
//                     />
//                     <label
//                       htmlFor={price.key}
//                       className="text-lg font-normal text-gray-400"
//                     >
//                       {price.name}
//                     </label>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {buyItem && (
//         <LmsBuyDrawer
//           isVisible={isDrawerVisible}
//           onClose={closeDrawer}
//           buyItemPrice={buyItem?.packagePrice}
//           buyItemName={buyItem?.packageName}
//           buyItemId={buyItem?.packageId}
//           buyItemBanner={buyItem?.packageBanner}
//           buyItemType={buyItem?.packageType}
//           buyItemBatchIds={buyItem?.packageContainingBatches}
//           fetchPackages={fetchPackages}
//           fetchUserData={fetchUserData}
//           uid={user?.uid}
//         />
//       )}
//     </>
//   );
// }

// export default PackageListView;

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../provider/Auth.provider";
import LmsBuyDrawer from "./LmsBuyDrawer/LmsBuyDrawer";
import ButtonComponent from "../CssComponents/ButtonComponent/ButtonComponent";
import graduation_cap from "../../assets/graduation_cap.png";
import time_png from "../../assets/time.png";
import { Checkbox } from "antd";
import { getClubTrainersWithIdAndNameOnly } from "../../service/getUsers/getClubTrainers";
import BreadcrumbComponent from "../CssComponents/BreadCrumbComponents";
import { getFilteredPackages } from "../../service/getPackages/getFilteredPackages"; // New backend filter function

function PackageListView({ userData, fetchUserData }) {
  const navigate = useNavigate();
  const { user } = useAuth();

  const [packages, setPackages] = useState([]);
  const [buyItem, setBuyItem] = useState(null);
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const [trainers, setTrainers] = useState([]);

  // Filter states
  const [selectedPackageType, setSelectedPackageType] = useState("all");
  const [selectedInstructors, setSelectedInstructors] = useState([]);
  const [selectedPriceFilter, setSelectedPriceFilter] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");

  const packageType = [
    { label: "All", value: "all" },
    { label: "Digital Product", value: "package_dp" },
    { label: "Live Classes", value: "package_lc" },
  ];

  const priceFilters = [
    { name: "Low to High", key: "low-to-high" },
    { name: "High to Low", key: "high-to-low" },
    { name: "Paid", key: "paid" },
    { name: "Free", key: "free" },
    { name: "All", key: "all" },
  ];

  const breadcrumbItems = [{ name: "Home", url: "/" }, { name: "Package" }];

  // Fetch trainers for sidebar
  useEffect(() => {
    const fetchTrainers = async () => {
      const trainersData = await getClubTrainersWithIdAndNameOnly();
      setTrainers(trainersData);
    };
    fetchTrainers();
  }, []);

  // Fetch packages from backend whenever filters change
  const fetchPackages = async () => {
    try {
      const data = await getFilteredPackages({
        packageType: selectedPackageType,
        instructorIds: selectedInstructors,
        priceFilter: selectedPriceFilter,
        searchTerm: searchTerm,
      });
      setPackages(data);
    } catch (err) {
      console.error("Error fetching packages:", err);
      setPackages([]);
    }
  };

  useEffect(() => {
    fetchPackages();
  }, [
    selectedPackageType,
    selectedInstructors,
    selectedPriceFilter,
    searchTerm,
  ]);

  // Handlers
  const handleBuyClick = (item) => {
    setBuyItem(item);
    setIsDrawerVisible(true);
  };

  const closeDrawer = () => {
    setIsDrawerVisible(false);
    setBuyItem(null);
  };

  const handleInstructorChange = (instructorId) => {
    const updatedInstructors = selectedInstructors.includes(instructorId)
      ? selectedInstructors.filter((id) => id !== instructorId)
      : [...selectedInstructors, instructorId];
    setSelectedInstructors(updatedInstructors);
  };

  const handlePriceChange = (priceKey) => {
    setSelectedPriceFilter(priceKey);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
    <>
      <div className="bg-black text-white font-poppins py-10 px-14 flex flex-col gap-4 w-full">
        <BreadcrumbComponent items={breadcrumbItems} />

        <div className="flex gap-8 w-full">
          {/* Packages List */}
          <div className="flex flex-col gap-6 w-full">
            <div className="flex justify-between">
              <h1 className="text-2xl font-medium">All Packages</h1>
              <input
                className="p-4 py-2 bg-black border border-yellow-500 rounded outline-none"
                value={searchTerm}
                onChange={handleSearchChange}
                placeholder="Search packages..."
              />
            </div>

            {packages.length > 0 ? (
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {packages.map((pkg) => (
                  <div
                    key={pkg.id}
                    className="flex flex-col items-start w-full bg-secondary-bg rounded-xl overflow-hidden"
                  >
                    <img
                      src={pkg.packageBanner}
                      alt={pkg.packageName}
                      className="w-full h-full object-cover max-h-64 object-top"
                    />
                    <div className="w-full py-4 px-6 flex flex-col gap-4">
                      <div className="flex flex-col gap-2">
                        <h2 className="text-xl font-medium leading-9">
                          {pkg.packageName}
                        </h2>
                        <div className="flex gap-4 text-sm text-gray-400">
                          <div className="flex items-center gap-2">
                            <img
                              src={time_png}
                              alt="time"
                              className="h-4 w-4"
                            />
                            <div>{pkg.packageDuration}</div>
                          </div>
                          <div className="flex items-center gap-2">
                            <img
                              src={graduation_cap}
                              alt="graduation"
                              className="h-4 w-4"
                            />
                            <div>{pkg.totalStudents} Students</div>
                          </div>
                        </div>
                      </div>
                      <hr className="w-full border-t border-gray-500" />
                      <div className="w-full flex justify-between items-center">
                        <div className="bg-custom-gradient bg-clip-text text-transparent text-2xl">
                          ₹{" "}
                          {parseFloat(
                            pkg?.packagePrice || pkg?.registrationPrice || 0
                          ).toLocaleString("en-IN")}
                        </div>
                        {userData?.buyItemIdsArray?.some(
                          (item) => item.buyItemId === pkg.id
                        ) ? (
                          <span className="text-green-600 font-semibold">
                            Already Purchased
                          </span>
                        ) : (
                          <ButtonComponent
                            onClick={() => handleBuyClick(pkg)}
                            buttonText="Buy Now"
                          />
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-gray-400 text-lg">
                <p>No packages available at the moment.</p>
              </div>
            )}
          </div>

          {/* Sidebar Filters */}
          <div className="w-1/3 flex flex-col gap-8">
            {/* Package Type */}
            <div className="flex flex-col gap-4">
              <label className="text-xl font-semibold text-white">
                Package Type
              </label>
              <div className="flex flex-col gap-2">
                {packageType.map((item) => (
                  <div key={item.value} className="flex items-center gap-2">
                    <Checkbox
                      id={item.value}
                      checked={selectedPackageType === item.value}
                      onChange={() => setSelectedPackageType(item.value)}
                    />
                    <label
                      htmlFor={item.value}
                      className="text-lg font-normal text-gray-400"
                    >
                      {item.label}
                    </label>
                  </div>
                ))}
              </div>
            </div>

            {/* Instructors */}
            <div className="flex flex-col gap-4">
              <label className="text-xl font-semibold text-white">
                Instructor
              </label>
              <div className="flex flex-col gap-2">
                {trainers?.map((item) => (
                  <div key={item.trainerId} className="flex gap-2 items-center">
                    <Checkbox
                      id={item.trainerId}
                      checked={selectedInstructors.includes(item.trainerId)}
                      onChange={() => handleInstructorChange(item.trainerId)}
                    />
                    <label
                      htmlFor={item.trainerId}
                      className="text-lg font-normal text-gray-400"
                    >
                      {item.trainerName}
                    </label>
                  </div>
                ))}
              </div>
            </div>

            {/* Price Filters */}
            <div className="flex flex-col gap-4">
              <label className="text-xl font-semibold text-white">Price</label>
              <div className="flex flex-col gap-2">
                {priceFilters.map((price) => (
                  <div key={price.key} className="flex items-center gap-2">
                    <Checkbox
                      id={price.key}
                      checked={selectedPriceFilter === price.key}
                      onChange={() => handlePriceChange(price.key)}
                    />
                    <label
                      htmlFor={price.key}
                      className="text-lg font-normal text-gray-400"
                    >
                      {price.name}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Buy Drawer */}
      {buyItem && (
        <LmsBuyDrawer
          isVisible={isDrawerVisible}
          onClose={closeDrawer}
          buyItemPrice={buyItem?.packagePrice}
          buyItemName={buyItem?.packageName}
          buyItemId={buyItem?.id}
          buyItemBanner={buyItem?.packageBanner}
          buyItemType={buyItem?.packageType}
          buyItemBatchIds={buyItem?.packageContainingBatches}
          fetchPackages={fetchPackages}
          fetchUserData={fetchUserData}
          uid={user?.uid}
        />
      )}
    </>
  );
}

export default PackageListView;
